import { Theme } from '@mui/material';

export default function LoadingButton(theme: Theme) {
  return {
    MuiLoadingButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            color: 'white',
          },
        },
      ],
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.primary.main,
          },
          '.MuiLoadingButton-loadingIndicator': {
            color: 'white',
          },
        },
      },
    },
  };
}
